module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-6-m4.e39f5d00.jpg";